import { useState } from "react"
import { Checkbox } from 'antd'

const BobListField = ({ fieldDesc, fieldValue, updateFieldValue }) => {

    const handleIsApplicableChange = () => {
        let updatedIsApplicable = !fieldValue?.isApplicable
        let updatedValues = fieldValue?.values
        if(!updatedIsApplicable) {
            updatedValues = null
        } else {
            updatedValues = [null]
        }

        let updatedFieldValue = {"isApplicable": updatedIsApplicable, "values": updatedValues}

        updateFieldValue(updatedFieldValue)
    }

    const handleValueChange = (index, newValue) => {
        let updatedValues = fieldValue?.values.map((oldValue, i) => (i === index ? newValue : oldValue))

        let updatedFieldValue = {...fieldValue, "values": updatedValues}

        updateFieldValue(updatedFieldValue)
    }

    const addValue = (e) => {
         e.preventDefault()

         let updatedValues = [...fieldValue?.values, null]
         let updatedFieldValue = {...fieldValue, "values": updatedValues}

         updateFieldValue(updatedFieldValue)
    }

    const deleteValue = (e) => {
        e.preventDefault()

        if(fieldValue?.values.length === 1) {
            return
        }

        let updatedValues = [...fieldValue?.values]
        updatedValues.splice(-1)

        let updatedFieldValue = {...fieldValue, "values": updatedValues}

        updateFieldValue(updatedFieldValue)
    }

    return (
        <>
            <div className="bob-list-field-desc">
                <span>{fieldDesc}</span>
                <Checkbox checked={!fieldValue?.isApplicable} onChange={() => handleIsApplicableChange()}>N/A</Checkbox>
            </div>
            <div className="bob-list-field-container">
                { fieldValue.isApplicable && fieldValue.values && 
                    <>
                        {
                            fieldValue?.values.map((value, index) => {
                                return (
                                    <div className="form-group">
                                        <input className="inpt" type={`value${index}`} id={`value${index}`} name={`value${index}`} required value={fieldValue?.values[index]} onChange={(e) => handleValueChange(index, e.target.value)} />
                                    </div>
                                )
                            })
                        }
                        <div className="add-remove-bob-list">
                            <button type="button" onClick={(e) => addValue(e)}>Add</button>
                            {fieldValue?.values?.length > 1 && <button type="button" onClick={(e) => deleteValue(e)}>Remove</button>}
                        </div>
                    </>
                }
                
            </div>
        </>
    )
}

export default BobListField